<template>
  <div
    class="sb-card"
    :class="{
      'sb-card--loading': isLoading,
    }"
  >
    <slot></slot>
  </div>
</template>
<script lang="ts" setup>
import { computed, provide } from 'vue'

export type SbCardProps = {
  isLoading?: boolean
}

const props = withDefaults(defineProps<SbCardProps>(), {
  isLoading: false,
})

const cardContext = computed(() => {
  return { isLoading: props.isLoading }
})

provide('cardContext', cardContext)
</script>
